import PropTypes from "prop-types";

/** Checkbox cards, one per brand website. */
function WebsiteChoices({ brands, selected, onToggle, noun }) {
	return (
		<div className="choices two">
			{brands.map((brand) => (
				<label className="choice" key={brand}>
					<input
						type="checkbox"
						name="brand"
						value={brand}
						checked={selected.includes(brand)}
						onChange={() => onToggle(brand)}
					/>
					<span>
						<b>{brand}</b>
						<small>
							{brand} {noun}
						</small>
					</span>
				</label>
			))}
		</div>
	);
}

WebsiteChoices.propTypes = {
	brands: PropTypes.arrayOf(PropTypes.string).isRequired,
	selected: PropTypes.arrayOf(PropTypes.string).isRequired,
	onToggle: PropTypes.func.isRequired,
	noun: PropTypes.string.isRequired,
};

export default WebsiteChoices;
